<template funtional>
    <context-menu class="pick-context-menu" :ref="id">
      <ContextMenuPick title="journal" icon="FeatherIcon" @contextMenuClicked="$emit('click', 'freeWrite')"/>
      <ContextMenuPick title="discovery question" icon="CoffeeIcon" @contextMenuClicked="$emit('click', 'discoveryQuestion')"/>
      <ContextMenuPick title="mood tracker" icon="SmileIcon" @contextMenuClicked="$emit('click', 'moodTracker')"/>
      <ContextMenuPick title="life balance" icon="HexagonIcon" @contextMenuClicked="$emit('click', 'lifeBalance')"/>
    </context-menu>

</template>

<script>
export default {
  props: ['id'],
  computed: {
    isMobile () {
      // return true
      return this.$store.getters.isMobile || this.windowWidth <= 1024
    },
  },
  methods: {
    open () {
      // this.$root.$emit('closeAllContextMenus')

      if (this.$refs[this.id]) {
        this.$refs[this.id].open()
      }
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs[this.id]) {
        this.$refs[this.id].ctxVisible = false
      }
    })
  },
}
</script>


<style>

.pick-context-menu {
  font-size: 8rem;
}

</style>
